import {
  LessonsStepDefinition,
  PracticeStepDefinition,
  stepTypes,
} from "@/components/Lessons/Lesson/stepsDefinition";

/**
 * Shared route + store context for the current lesson step (progress pin and student task assign).
 */
export default {
  computed: {
    stepNumber() {
      switch (this.$route.name) {
        case "exercise":
          return Number.parseInt(this.$route.params.index) || 1;

        case "guided-lesson":
          if (this.stepDefinition.key === "Grammar") {
            if (this.$route.query.gn === undefined) {
              return -1;
            }
            return Number.parseInt(this.$route.query.gn) || 0;
          }

          if (this.stepDefinition.key === "Speaking") {
            return Number.parseInt(this.$route.query.sn) || 0;
          }

          if (this.stepDefinition.key === "Homework") {
            return Number.parseInt(this.$route.query.hn) || 0;
          }

          return 0;

        case "practice":
          if (this.stepDefinition.key === "Speaking") {
            return Number.parseInt(this.$route.query.sn) || 0;
          }

          if (this.stepDefinition.key === "Homework") {
            return Number.parseInt(this.$route.query.hn) || 0;
          }

          return 0;

        default:
          return 0;
      }
    },
    currentStep() {
      return this.$store.getters["lesson/step"];
    },
    stepDefinition() {
      switch (this.$route.name) {
        case "introduction":
          return stepTypes.find((step) => step.key === "TEACH_INTRO");
        case "guided-lesson": {
          const stepName = LessonsStepDefinition[this.currentStep];
          return stepTypes.find(
            (type) => type.section === "TEACHER_LESSON" && type.key === stepName,
          );
        }
        case "practice": {
          const practiceStepName = PracticeStepDefinition[this.currentStep];
          return stepTypes.find(
            (type) => type.section === "PRACTICE" && type.key === practiceStepName,
          );
        }
        case "exercise":
          return stepTypes.find((step) => step.key === "GRAMMAR_EXERCISE");
        default:
          return undefined;
      }
    },
    stepType() {
      return this.stepDefinition?.value;
    },
    currentLesson() {
      return this.$store.getters["modules/currentLesson"];
    },
    stepUuid() {
      switch (this.$route.name) {
        case "introduction":
        case "guided-lesson":
          return this.$store.getters["lesson/teacher_lesson"]?.[this.stepDefinition?.lessonKey];

        case "practice":
          return this.$store.getters["lesson/practice"]?.[this.stepDefinition?.lessonKey];
        case "exercise":
          return this.$store.getters["lesson/grammar"]?.uuid;
        default:
          return "";
      }
    },
  },
};
